import { Divider, Stack, Typography } from "@mui/material";
import { Colors } from "Components/Layout/Themes/Colors";
import { DoneIcon } from "Components/Shared/Icons";
import { ConfirmBox } from "Components/Transactions/Anonymous/ConfirmBox";
import { SignupOrInvoice } from "Components/Transactions/Anonymous/SuccessfulTransactionInfo/SignupOrInvoice";
import { useState } from "react";
import { Resources, useResource } from "Translations/Resources";

const ComponentResources = Resources.Transactions.SuccessPayment;

type Props = {
  transactionPublicID: string;
};

export const SuccessfulTransactionGeneralInfo = ({
  transactionPublicID,
}: Props) => {
  const [wasEmailInvoiceSent, setWasEmailInvoiceSent] = useState(false);

  const { t } = useResource();

  if (wasEmailInvoiceSent) {
    return <ConfirmBox />;
  }

  return (
    <Stack alignItems="center" gap={1}>
      <DoneIcon color={Colors.Green} />
      <Typography variant="h5" fontWeight={600}>
        {t(ComponentResources.Title)}
      </Typography>
      <Typography lineHeight="28px" textAlign="center">
        {t(ComponentResources.DescriptionFirstLine)}
        <br />
        {t(ComponentResources.DescriptionSecondLine)}
      </Typography>
      <Divider sx={{ opacity: 0.5 }} />
      <SignupOrInvoice
        transactionPublicID={transactionPublicID}
        setWasEmailInvoiceSent={setWasEmailInvoiceSent}
      />
    </Stack>
  );
};
